import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function Implementacion() {
  const { t } = useTranslation('landing');

  const standardSteps = t('implementacion.standard.steps', { returnObjects: true });
  const advancedSteps = t('implementacion.advanced.steps', { returnObjects: true });

  return (
    <motion.section
      id="impl"
      className={styles.section}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className={styles.container}>
        <div className={styles.center}>
          <span className={styles.tag}>{t('implementacion.tag')}</span>
          <h2 className={styles.title}>{t('implementacion.title')}</h2>
          <p className={styles.subtitle}>{t('implementacion.subtitle')}</p>
        </div>
        <div className={styles.grid}>
          <div className={styles.card}>
            <span className={`${styles.badge} ${styles.badgeStd}`}>
              {t('implementacion.standard.badge')}
            </span>
            <div className={`${styles.time} ${styles.timeDark}`}>
              {t('implementacion.standard.time')}
            </div>
            <div className={`${styles.sub} ${styles.subMuted}`}>
              {t('implementacion.standard.sub')}
            </div>
            <div className={styles.steps}>
              {standardSteps.map((step, i) => (
                <div key={i} className={`${styles.step} ${styles.stepDark}`}>
                  <div className={`${styles.dot} ${styles.dotBlue}`}>{i + 1}</div>
                  {step}
                </div>
              ))}
            </div>
          </div>
          <div className={`${styles.card} ${styles.featured}`}>
            <span className={`${styles.badge} ${styles.badgeAdv}`}>
              {t('implementacion.advanced.badge')}
            </span>
            <div className={`${styles.time} ${styles.timeLight}`}>
              {t('implementacion.advanced.time')}
            </div>
            <div className={`${styles.sub} ${styles.subLight}`}>
              {t('implementacion.advanced.sub')}
            </div>
            <div className={styles.steps}>
              {advancedSteps.map((step, i) => (
                <div key={i} className={`${styles.step} ${styles.stepLight}`}>
                  <div className={`${styles.dot} ${styles.dotOutline}`}>{i + 1}</div>
                  {step}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.note}>
            {t('implementacion.note.icon')}{' '}
            <strong>{t('implementacion.note.bold1')}</strong>{' '}
            {t('implementacion.note.text')}{' '}
            <strong>{t('implementacion.note.bold2')}</strong>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
